<template lang="pug">
  #input-service-contents
    #tmp-container.mt-3.d-flex.mx-auto
      b-card.w-100.mt-1
        input-service-contents-form(v-model="value")
      price-board(v-model="value")
</template>

<script>
import InputServiceContentsForm from "@/components/firstOrder/InputServiceContentsForm";
import PriceBoard from "@/components/PriceBoard";

export default {
  name: "InputServiceContents",
  components: {
    PriceBoard,
    InputServiceContentsForm,
  },
  props: {
    value: {type: Object, required: false}
  },
  methods: {
  }
}
</script>

<style scoped>
.stepper-style {
  width: 900px;
  background-color: #c0c0c0;
  color: #ffffff;
}
.active-step {
  background-color: #4169e1;
}
.next-icon {
  margin-top: 2px;
}
</style>